export const NOTIFY_SDK_VERSION = "1.4.1";
